import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getAsignablesOt, putAsignablesOt, getPersonasAsignables } from '../../api/client'

// Órdenes de trabajo > Permisos: which areas and cargos (people's job titles)
// can be put to work on an OT. Edited with "administrar_permisos".
export default function Asignables() {
  const { t } = useTranslation('operations')
  const [cfg, setCfg] = useState(null)
  const [sel, setSel] = useState({ areas: [], cargos: [] })
  const [personas, setPersonas] = useState([])
  const [estado, setEstado] = useState('')           // '' | guardando | guardado | error
  const [detalle, setDetalle] = useState('')         // what the server said when it refused

  const cargar = () => {
    getAsignablesOt().then(c => { setCfg(c); setSel({ areas: c.areas, cargos: c.cargos }) }).catch(() => setEstado('error'))
    getPersonasAsignables().then(setPersonas).catch(() => {})
  }
  useEffect(cargar, [])

  if (!cfg) return null
  const alternar = (k, v) => { setEstado(''); setSel(s => ({ ...s, [k]: s[k].includes(v) ? s[k].filter(x => x !== v) : [...s[k], v] })) }
  const cambiado = JSON.stringify([...sel.areas].sort()) !== JSON.stringify([...cfg.areas].sort())
    || JSON.stringify([...sel.cargos].sort()) !== JSON.stringify([...cfg.cargos].sort())
  const guardar = async () => {
    setEstado('guardando'); setDetalle('')
    try { const c = await putAsignablesOt(sel); setCfg(c); setEstado('guardado'); getPersonasAsignables().then(setPersonas).catch(() => {}) }
    catch (e) { const d = e.response?.data?.detail; setDetalle(typeof d === 'string' ? d : (d?.message || '')); setEstado('error') }
  }
  const caja = (k, v, etiqueta) => (
    <label key={v} className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-sm ${
      sel[k].includes(v) ? 'border-indigo-300 bg-indigo-50 text-indigo-900' : 'border-gray-200 bg-white text-gray-700'} ${cfg.puede_editar ? 'cursor-pointer' : 'opacity-70'}`}>
      <input type="checkbox" checked={sel[k].includes(v)} disabled={!cfg.puede_editar} onChange={() => alternar(k, v)} />
      {etiqueta}
    </label>
  )
  return (
    <section className="rounded-xl border border-gray-200 bg-white p-5 mt-8">
      <h2 className="text-base font-semibold text-gray-900">{t('ot.asignables.titulo')}</h2>
      <p className="text-sm text-gray-500 mb-4">{t('ot.asignables.ayuda')}</p>
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">{t('ot.asignables.areas')}</h3>
      <div className="flex flex-wrap gap-2 mb-4">{cfg.opciones_areas.map(a => caja('areas', a.code, a.name))}</div>
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">{t('ot.asignables.cargos')}</h3>
      <div className="flex flex-wrap gap-2 mb-4">
        {cfg.opciones_cargos.length ? cfg.opciones_cargos.map(c => caja('cargos', c, c))
          : <span className="text-sm text-gray-400">{t('ot.asignables.sinCargos')}</span>}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {cfg.puede_editar && (
          <button type="button" onClick={guardar} disabled={!cambiado || estado === 'guardando'}
            className="bg-gray-900 text-white px-4 py-1.5 rounded-lg text-sm font-medium hover:bg-gray-800 disabled:opacity-40">
            {t('ot.asignables.guardar')}
          </button>
        )}
        {estado === 'guardado' && <span className="text-sm text-emerald-700">✓ {t('ot.asignables.guardado')}</span>}
        {estado === 'error' && <span className="text-sm text-red-600">{t('ot.asignables.fallo')}{detalle ? ` ${detalle}` : ''}</span>}
        <span className="text-sm text-gray-600">{t('ot.asignables.n', { count: personas.length })}</span>
      </div>
      {personas.length > 0 && (
        <p className="mt-2 text-xs text-gray-500 leading-relaxed">{personas.map(p => p.nombre).join(' · ')}</p>
      )}
    </section>
  )
}
